import "./Gallery.css";
import img1 from "../images/custom_galeri_banyo.jpg";
import img2 from "../images/custom_galeri_zemin.jpg";
import img3 from "../images/item_merdiven_kaplama.jpg";
import img4 from "../images/projects/mezar/mezar6.jpeg";
import img5 from "../images/item_ic_dekorasyon.jpg"

export default function Gallery() {
  const images = [
    { src: img1, title: "Banyo"},
    { src: img2, title: "Zemin" },
    { src: img3, title: "Merdiven" },
    { src: img4, title: "Mezar" },
    { src: img5, title: "İç Mekan" }
  ];

  return (
    <section className="gallery-card">
     

      <div className="grid">
        {images.map((item, i) => (
          <div className="card" key={i}>
            <img src={item.src} alt="" />
            <div className="overlay-text">{item.title}</div>
          </div>
        ))}
      </div>
    </section>
  );
}